import { baseApi } from "@/services/api/baseApi";

export const courseSlice = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    // changePassword: builder.mutation({
    //   query: (body) => ({
    //     url: "password",
    //     method: "PATCH",
    //     body,
    //   }),
    // }),
    // forgotPassword: builder.mutation({
    //   query: (body) => ({
    //     url: "forgot-password",
    //     method: "POST",
    //     body,
    //   }),
    // }),
    // resetPassword: builder.mutation({
    //   query: (body) => ({
    //     url: "reset-password",
    //     method: "POST",
    //     body,
    //   }),
    // }),

    getDaysContent: builder.query({
      query: ({ id }) => ({
        url: `/days/${id}/contents`,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        // Transform the response if needed
        return response?.data;
      },

      // transformErrorResponse: (error: any) => {
      //   return error?.data;
      // },
    }),

    getCourseDays: builder.query({
      query: () => ({
        url: `/course/days`,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        // Transform the response if needed
        return response?.data;
      },
    }),

    getCourseDetails: builder.query({
      query: ({ courseId }) => ({
        url: `/content/${courseId}/details`,
        method: "GET",
      }),
      providesTags: ["ContentDetails"],
      transformResponse: (response: any) => {
        // Transform the response if needed
        return response?.data;
      },
    }),
  }),
});

export const {
  useGetDaysContentQuery,
  useGetCourseDaysQuery,
  useGetCourseDetailsQuery,

  useLazyGetCourseDaysQuery,
  useLazyGetDaysContentQuery,

  // useChangePasswordMutation,
  // useResetPasswordMutation,
  // useForgotPasswordMutation,
} = courseSlice;
